export const CHECKOUT_URL =
  'https://mega-pack-vuelve-a-ti.impultienda.ar/checkout'

export const PRICE = '$19.990'
export const TOTAL_VALUE = '$73.000'
export const BONUS_VALUE = '$35.000'

export const BRAND = 'CM Digital Pro™'
export const PRODUCT = 'MEGA PACK VUELVE A TI™'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/65rAJUqFXrxAuFTd4Kq9EM/Imagen_de_Codex_31_ago_2026,_19_19_51.png'

export const heroBullets = [
  'eBook VUELVE A TI™',
  'Workbook MI CAMINO DE REGRESO',
  'Diario guiado 14 DÍAS PARA VOLVER A MÍ',
  '30 Tarjetas de afirmaciones',
  '6 Bonos estratégicos',
  'Método VUELVE™',
  'Material 100% digital — acceso inmediato',
]

export const proofStats = [
  { value: '14', label: 'Días de reconexión' },
  { value: '4', label: 'Tomos completos' },
  { value: '6', label: 'Bonos incluidos' },
  { value: '100%', label: 'Digital y a tu ritmo' },
]

export const testimonials = [
  {
    quote:
      'Me ayudó a darme cuenta de cuánto tiempo llevaba dejándome para después.',
    author: 'Laura M.',
    location: 'Buenos Aires',
  },
  {
    quote: 'Las preguntas me hicieron frenar y preguntarme qué necesitaba yo.',
    author: 'Carolina R.',
    location: 'Córdoba',
  },
  {
    quote:
      'Empecé a recuperar pequeños momentos para mí sin sentir que tenía que cambiar toda mi vida.',
    author: 'Mariana G.',
    location: 'Rosario',
  },
  {
    quote: 'El diario me ayudó a tener una guía clara para cada día.',
    author: 'Andrea P.',
    location: 'Mendoza',
  },
]

export const TESTIMONIALS_NOTE =
  'Importante: reemplazar nombres, ubicaciones y textos por testimonios reales antes de publicar.'

export const painPoints = [
  'Te levantás pensando en todo lo que tenés que resolver.',
  'Estás pendiente de tu familia, tu trabajo, tu casa y tus responsabilidades.',
  'Decís “sí” aunque estés cansada.',
  'Te cuesta poner límites.',
  'Sentís culpa cuando hacés algo solamente para vos.',
  'Postergás actividades que te hacían bien.',
  'Esperás tener más tiempo para empezar a cuidarte.',
]

export const objections = [
  'Las necesidades de los demás',
  'Los pendientes',
  'Las obligaciones',
  'Lo urgente',
  'Lo que esperan de vos',
]

export const audience = [
  'Mujeres que sienten que siempre están disponibles para los demás.',
  'Mujeres agotadas de intentar llegar a todo.',
  'Mujeres que sienten culpa cuando se priorizan.',
  'Mujeres que necesitan recuperar espacios propios.',
  'Mujeres que quieren aprender a poner límites.',
  'Mujeres que extrañan sentirse conectadas consigo mismas.',
]

export const pillars = [
  {
    title: 'Observarme',
    desc: 'Reconocer cómo estoy, qué necesito y qué está consumiendo mi energía.',
  },
  {
    title: 'Elegirme',
    desc: 'Empezar a darme un lugar, recuperar espacios personales y practicar límites conscientes.',
  },
  {
    title: 'Volver a mí',
    desc: 'Crear pequeñas prácticas y rituales que me ayuden a mantener la conexión conmigo.',
  },
]

export const method = [
  { letter: 'V', title: 'Verme', desc: 'Reconocer cómo estoy.' },
  { letter: 'U', title: 'Ubicarme', desc: 'Descubrir qué necesito.' },
  { letter: 'E', title: 'Elegirme', desc: 'Darme nuevamente un lugar.' },
  { letter: 'L', title: 'Limitar', desc: 'Proteger mi tiempo y energía.' },
  { letter: 'V', title: 'Volver', desc: 'Recuperar aquello que me hace bien.' },
  {
    letter: 'E',
    title: 'Encarnar',
    desc: 'Convertirlo en una práctica cotidiana.',
  },
]

export const results = [
  'Reconocer cómo estás realmente.',
  'Volver a escuchar tus necesidades.',
  'Identificar qué drena tu energía.',
  'Detectar dónde te estás dejando para después.',
  'Trabajar la culpa de priorizarte.',
  'Practicar límites más conscientes.',
  'Recuperar pequeños espacios personales.',
  'Volver a actividades que te hacen bien.',
  'Crear un ritual diario de reconexión.',
  'Diseñar un plan para continuar después de los 14 días.',
]

export const tomos = [
  {
    title: 'Vuelve a Ti™',
    lead: 'El camino de regreso a ti misma',
    desc: 'Una guía práctica para comprender por qué podés terminar dejándote para después y cómo empezar a reconectar contigo.',
    includes: [
      'Piloto automático',
      'Necesidades personales',
      'Culpa al priorizarte',
      'Límites conscientes',
      'Autocuidado realista',
      'Espacios propios',
      'Pequeños placeres',
      'Rituales personales',
    ],
    value: '$12.000',
  },
  {
    title: 'Mi camino de regreso',
    lead: 'Workbook práctico',
    desc: 'Ejercicios para transformar la reflexión en decisiones concretas.',
    includes: [
      'Rueda de reconexión',
      'Inventario de necesidades',
      'Mapa de energía',
      'Lo que me nutre y me drena',
      'Mis límites pendientes',
      'Mis espacios personales',
      'Mi autocuidado realista',
      'Plan personal de 30 días',
    ],
    value: '$9.000',
  },
  {
    title: '14 días para volver a mí',
    lead: 'Diario guiado',
    desc: 'Una jornada por día, con una estructura simple para sostener la práctica.',
    includes: [
      'Intención',
      'Reflexión',
      'Journaling',
      'Microacción',
      'Afirmación',
      'Ritual sensorial',
    ],
    value: '$10.000',
  },
  {
    title: '30 afirmaciones para volver a ti',
    lead: 'Tarjetas digitales',
    desc: 'Recordatorios para acompañarte durante y después de los 14 días.',
    includes: [
      '“Mis necesidades también merecen espacio.”',
      '“Hoy no necesito hacerlo todo.”',
      '“Un límite no significa falta de amor.”',
      '“Mi bienestar también importa.”',
    ],
    value: '$7.000',
  },
]

export const tomoIncludes = [
  'Contenido organizado paso a paso',
  'Reflexiones guiadas',
  'Ejercicios prácticos',
  'Herramientas de journaling',
  'Microacciones',
  'Rituales sencillos',
  'Material descargable',
  'Recursos para volver a utilizar cuando los necesites',
]

export const bonuses = [
  {
    title: 'Kit SOS — Vuelve a ti en 10 minutos',
    desc: 'Una práctica rápida para esos momentos en los que necesitás detenerte y volver a conectar contigo.',
    value: '$7.000',
  },
  {
    title: '21 días de autocuidado real',
    desc: '21 pequeñas acciones para continuar cuidándote después de completar la experiencia principal.',
    value: '$6.000',
  },
  {
    title: '50 preguntas para volver a ti',
    desc: 'Preguntas de journaling para utilizar cada vez que necesites escucharte y ordenar lo que sentís.',
    value: '$5.000',
  },
  {
    title: 'Mi mapa de límites',
    desc: 'Una guía práctica para reconocer dónde necesitás proteger mejor tu tiempo y energía.',
    value: '$6.000',
  },
  {
    title: 'Rituales para volver a mí',
    desc: 'Pequeños rituales para comenzar el día, bajar el ritmo, reconectar y cerrar la jornada.',
    value: '$6.000',
  },
  {
    title: 'Plan 30 días — Sigo eligiéndome',
    desc: 'Una hoja de ruta para continuar aplicando lo aprendido después del día 14.',
    value: '$5.000',
  },
]

export const valueStack = [
  { item: 'eBook VUELVE A TI™', value: '$12.000' },
  { item: 'Workbook MI CAMINO DE REGRESO', value: '$9.000' },
  { item: 'Diario 14 DÍAS PARA VOLVER A MÍ', value: '$10.000' },
  { item: '30 Tarjetas de afirmaciones', value: '$7.000' },
  { item: '6 Bonos estratégicos', value: '$35.000' },
]

export const changeRows = [
  { sin: 'Vivís en piloto automático.', con: 'Tenés una ruta de 14 días.' },
  { sin: 'No sabés qué necesitás.', con: 'Empezás a escucharte.' },
  {
    sin: 'Postergás tus espacios.',
    con: 'Recuperás espacios personales.',
  },
  {
    sin: 'Sentís culpa al priorizarte.',
    con: 'Reconocés tus necesidades sin culpa.',
  },
  { sin: 'Te cuesta poner límites.', con: 'Practicás pequeños límites.' },
  {
    sin: 'Esperás tener más tiempo.',
    con: 'Creás tu propio ritual de reconexión.',
  },
]

export const faqs = [
  {
    q: '¿Necesito experiencia previa?',
    a: 'No. Está diseñado para que puedas comenzar desde el primer día.',
  },
  {
    q: '¿Cuánto tiempo necesito?',
    a: 'Podés incorporar las prácticas a tu rutina y avanzar a tu propio ritmo.',
  },
  {
    q: '¿Tengo que hacer los 14 días seguidos?',
    a: 'No. La experiencia está organizada en 14 jornadas, pero podés adaptarla a tus tiempos.',
  },
  {
    q: '¿Cómo recibo el Mega Pack?',
    a: 'En formato 100% digital después de confirmar tu compra.',
  },
  {
    q: '¿Qué incluye?',
    a: 'Los 4 tomos completos + los 6 bonos incluidos en esta oferta.',
  },
  {
    q: '¿Es terapia?',
    a: 'No. Es un producto educativo de bienestar, reflexión y autocuidado. No reemplaza atención médica o psicológica profesional.',
  },
  {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días de garantía según las condiciones de compra.',
  },
]

export const withoutSystem = [
  'Seguís esperando tener tiempo.',
  'Seguís priorizando todos los pendientes.',
  'Tus necesidades quedan para después.',
  'Te cuesta decir que no.',
  'Seguís postergando aquello que te hace bien.',
  'Seguís diciéndote: “Cuando todo se calme, voy a ocuparme de mí.”',
]

export const withSystem = [
  'Tenés una ruta.',
  'Tenés ejercicios.',
  'Tenés preguntas para escucharte.',
  'Tenés herramientas para revisar tus límites.',
  'Tenés pequeñas acciones diarias.',
  'Tenés rituales de reconexión.',
  'Tenés un plan para continuar.',
  'Tenés una forma concreta de empezar.',
]
